/* ================================================================
   Optional WebGL layer. Loads Three.js; on ANY failure it hands
   control back to the tested 2D software-3D renderer.
   Must be defined BEFORE core.js runs.
   ================================================================ */
var VPH_BOOT = (function(){
  var SRC='https://cdn.jsdelivr.net/npm/three@0.128.0/build/three.min.js';
  function webglOK(){
    try{ var c=document.createElement('canvas');
      return !!(window.WebGLRenderingContext && (c.getContext('webgl')||c.getContext('experimental-webgl')));
    }catch(e){ return false; }
  }
  return function(fallback){
    if(!webglOK()){ fallback(); return; }
    var done=false;
    var to=setTimeout(function(){ if(!done){done=true; fallback();} }, 4000);
    var sc=document.createElement('script');
    sc.src=SRC; sc.async=true; sc.crossOrigin='anonymous';
    sc.onerror=function(){ if(!done){done=true; clearTimeout(to); fallback();} };
    sc.onload=function(){
      if(done) return; done=true; clearTimeout(to);
      try{
        if(!window.THREE || !window.THREE.InstancedMesh) throw new Error('no THREE');
        start3D();
      }catch(err){ try{ fallback(); }catch(e2){} }
    };
    document.head.appendChild(sc);
  };
  /* ---------------- WebGL instanced prisms ---------------- */
  function start3D(){
    var T=window.THREE;
    var cv=document.getElementById('vph-cv');
    var rend=new T.WebGLRenderer({canvas:cv, alpha:true, antialias:!VPH.MB});
    rend.setPixelRatio(Math.min(window.devicePixelRatio||1,2));
    rend.setClearAlpha(0);
    var scene=new T.Scene();
    var FOV=40;
    var cam=new T.PerspectiveCamera(FOV,1,10,6000);
    var key=new T.DirectionalLight(0xffffff,1.05);
    key.position.set(-0.42,0.60,0.68);
    scene.add(key);
    scene.add(new T.AmbientLight(0xffffff,0.26));
    /* true triangular pyramid: 4 triangular faces, flat-shaded */
    var geo=new T.TetrahedronBufferGeometry(1.02,0);
    geo=geo.toNonIndexed ? geo.toNonIndexed() : geo;
    geo.computeVertexNormals();
    var mat=new T.MeshLambertMaterial({color:0xffffff});
    var N=VPH.N;
    var im=new T.InstancedMesh(geo,mat,N);
    im.instanceMatrix.setUsage(T.DynamicDrawUsage);
    im.frustumCulled=false;
    scene.add(im);
    var dummy=new T.Object3D(), col=new T.Color();
    var ALB=[0.020,0.170,0.250];
    function resize3(){
      var vw=VPH.vw(), vh=VPH.vh();
      cam.aspect=vw/vh;
      cam.fov=FOV;
      cam.position.set(0,0,(vh/2)/Math.tan(FOV*Math.PI/360));
      cam.lookAt(0,0,0);
      cam.updateProjectionMatrix();
      rend.setSize(vw,vh,false);
    }
    resize3();
    window.addEventListener('resize',resize3,{passive:true});
    /* seed instanceColor so the attribute exists */
    for(var s0=0;s0<N;s0++){ col.setRGB(0,0,0); im.setColorAt(s0,col); }
    function frame3(ts){
      requestAnimationFrame(frame3);
      var el=VPH.compute(ts);
      var vw=VPH.vw(), vh=VPH.vh();
      if(el<0){ rend.render(scene,cam); return; }
      var P=VPH.P, SX=VPH.SX, SY=VPH.SY, SA=VPH.SA, SK=VPH.SK, SV=VPH.SV, SZ=VPH.SZ, SZW=VPH.SZW, SPZ=VPH.SPZ;
      var RMo=VPH.RM;
      for(var i=0;i<N;i++){
        if(!SV[i]){ dummy.position.set(0,0,-9000); dummy.scale.set(0.0001,0.0001,0.0001);
                    dummy.updateMatrix(); im.setMatrixAt(i,dummy.matrix); continue; }
        var q=P[i], a=SA[i], k=SK[i];
        var t=RMo?0:el;
        /* Scene 1 keeps every instance on one depth plane, so the camera
           reads level and square to the vial; Scenes 2/3 get full depth. */
        dummy.position.set(SX[i]-vw/2, -(SY[i]-vh/2), SZW[i]*(SPZ?SPZ[i]:1));
        dummy.rotation.set(q.ax+t*q.r1, q.ay+t*q.r2, q.az+t*q.r3);
        var sc=SZ[q.si]*k*1.02*(q.szb||1);
        dummy.scale.set(sc,sc,sc);
        dummy.updateMatrix();
        im.setMatrixAt(i,dummy.matrix);
        /* albedo carries depth; alpha folded in by lerping toward white */
        var alb=ALB[q.sh], f=1-a, c=alb+(1-alb)*f;
        col.setRGB(c,c,c);
        im.setColorAt(i,col);
      }
      im.instanceMatrix.needsUpdate=true;
      if(im.instanceColor) im.instanceColor.needsUpdate=true;
      rend.render(scene,cam);
    }
    requestAnimationFrame(frame3);
  }
})();
(function(){
var W=document.querySelector('.vph'); if(!W) return;
var RM=matchMedia('(prefers-reduced-motion:reduce)').matches;
var MB=innerWidth<750;
/* The mobile scene is a true scaled copy of the approved desktop one, not
   the same particles squeezed into a narrower frame. PS is the ratio of
   the two stage heights (0.42vh vs 0.76vh). Every pyramid and every drift
   amplitude scales by PS while the COUNT stays at the desktop value -
   exactly like photographing the desktop scene and printing it smaller.
   Pyramid size relative to spacing, and particles per unit of stage area,
   therefore come out identical to desktop instead of clumped.            */
var PS = MB ? 0.42/0.76 : 1;
var N  = 3800;
/* ---------------- canvas ---------------- */
var cv=document.createElement('canvas'); cv.id='vph-cv'; cv.setAttribute('aria-hidden','true');
document.body.appendChild(cv);
var g=null;
/* ---------------- sprite atlas ---------------- */
/* ---------------- 3D shard geometry + lighting ---------------- */
var SZ=[4.2*PS,6.0*PS,8.4*PS];
var K=0.62;
/* regular tetrahedron: 4 vertices, 4 triangular faces */
var LV=[[K,K,K],[K,-K,-K],[-K,K,-K],[-K,-K,K]];
var FC=[[0,1,2],[0,3,1],[0,2,3],[1,3,2]];
var LGT=(function(){var l=[-0.42,-0.60,0.68],n=Math.hypot(l[0],l[1],l[2]);
  return [l[0]/n,l[1]/n,l[2]/n];})();
var AMB=0.26, DIF=0.98, CAMD=1500;
var ALB=[0.020,0.170,0.250];
/* ---------------- vial geometry (design units) ---------------- */
var BW=150, VHT=725;      /* aspect 2.416, measured from reference */
function halfW(t){
  if(t<0||t>1) return 0;
  if(t<0.007) return 139*Math.sqrt(t/0.007);            /* cap dome            */
  if(t<0.095) return 139;                               /* cap barrel  .93     */
  if(t<0.198) return 133;                               /* crimp collar .885   */
  if(t<0.214){var a=(t-0.198)/0.016; return 133-26*a;}   /* collar underside    */
  if(t<0.288) return 107;                               /* neck        .713    */
  if(t<0.332){var b=(t-0.288)/0.044; return 107+41*b*b*(3-2*b);} /* shoulder    */
  if(t<0.425){var c=(t-0.332)/0.093; return 148+2*c;}
  if(t<0.935) return BW;                                /* body                */
  if(t<0.980){var d=(t-0.935)/0.045; return BW-23*d*d;}
  var e=(t-0.980)/0.020; return 127*Math.sqrt(Math.max(0,1-e*e));  /* base      */
}
var PWD=0.735;                                   /* measured powder line  */
var BANDS=[
 [0.000,0.095,0.66],[0.095,0.185,0.62],[0.185,0.200,0.92],
 [0.200,0.300,0.13],[0.300,PWD,0.065],
 [PWD,PWD+0.016,1.00],[PWD+0.016,0.978,0.66],[0.978,1.000,0.80]
];
function bandD(t){for(var i=0;i<BANDS.length;i++){if(t>=BANDS[i][0]&&t<BANDS[i][1])return BANDS[i][2];}return 0.8;}
function genVial(mul){
  var P=[], F=(N/3800)*(mul||1);
  /* rg: 0 outline/base  1 silver band  2 clear glass  3 powder
         4 black lid     5 separator rules            6 floating halo   */
  function put(x,y,z,rg){P.push([x, y-VHT/2, z, rg]);}
  /* ---------- 1. one continuous outer contour, uniform everywhere ---------- */
  function outline(t0,t1,total){
    var n=Math.round(total*F);
    for(var i=0;i<n;i++){
      var t=t0+(t1-t0)*(i/n), r=halfW(t); if(r<=0.5) continue;
      var side=(i&1)?1:-1;
      put(side*r+(Math.random()*2-1)*0.7, t*VHT+(Math.random()*2-1)*0.7,
          (Math.random()*2-1)*4, 0);
    }
  }
  /* Shell samplers. Both walk the layer continuously in t (stratified, so
     there is no ring banding and no clumping) and take theta straight from
     the arc they own, so `total` is the exact number of particles placed.
     ACUT splits the cylinder: wrap() owns the front and back faces,
     side() owns the two flanks. Together they cover the wall evenly.     */
  var ACUT=Math.acos(0.58);
  /* wall wrap: front/back only, never the silhouette (outline owns that) */
  function wrap(t0,t1,total,jit,rg){
    var n=Math.round(total*F);
    for(var i=0;i<n;i++){
      var t=t0+(t1-t0)*((i+Math.random())/n), r=halfW(t); if(r<=1) continue;
      var th=ACUT+Math.random()*(Math.PI-2*ACUT);
      if(i&1) th+=Math.PI;
      put(Math.cos(th)*(r+(Math.random()*2-1)*(jit||1.2)), t*VHT+(Math.random()*2-1)*1.4,
          Math.sin(th)*r, rg);
    }
  }
  /* thin continuous rule at one height, outline weight */
  function rule(t,total,rg){
    var n=Math.round(total*F), r=halfW(t), y=t*VHT;
    for(var i=0;i<n;i++){
      var th=(i+Math.random())/n*Math.PI*2;
      put(Math.cos(th)*r+(Math.random()*2-1)*0.6, y+(Math.random()*2-1)*0.6,
          Math.sin(th)*r, rg);
    }
  }
  function flat(t,n,r0,r1,yj,rg){          /* filled horizontal plate */
    n=Math.round(n*F); var y=t*VHT;
    for(var i=0;i<n;i++){
      var th=Math.random()*Math.PI*2, u=Math.sqrt(Math.random());
      var rr=r0+(r1-r0)*u;
      put(Math.cos(th)*rr, y+(yj?(Math.random()*2-1)*yj:0), Math.sin(th)*rr, rg);
    }
  }
  /* the two flanks wrap() leaves to the silhouette, filled just inside the
     contour so a layer reads solid without thickening its outline        */
  function side(t0,t1,total,rg,inset){
    var n=Math.round(total*F);
    for(var i=0;i<n;i++){
      var t=t0+(t1-t0)*((i+Math.random())/n), r=halfW(t); if(r<=2) continue;
      var th=(Math.random()*2-1)*ACUT;
      if(i&1) th+=Math.PI;
      /* reaches all the way out to just inside the contour, so the last
         strip before the silhouette is covered like the rest of the layer */
      var d=(r-(inset||3))*(0.78+Math.random()*0.22);
      put(Math.cos(th)*d, t*VHT+(Math.random()*2-1)*1.4, Math.sin(th)*d, rg);
    }
  }
  function fill(t0,t1,n,rg){               /* even cylindrical volume */
    n=Math.round(n*F);
    for(var i=0;i<n;i++){
      var t=t0+Math.random()*(t1-t0), r=halfW(t)*0.94;
      var th=Math.random()*Math.PI*2, u=Math.sqrt(Math.random());
      put(Math.cos(th)*r*u, t*VHT, Math.sin(th)*r*u, rg);
    }
  }
  outline(0.0035, 0.9975, 450);
  (function(){          /* closed, smoothly connected rounded base        */
    /* straight run down into the curve */
    var n=Math.round(90*F);
    for(var i=0;i<n;i++){
      var t=0.9700+(i/n)*0.0100, r=halfW(t), sd=(i&1)?1:-1;
      put(sd*r+(Math.random()*2-1)*0.7, t*VHT+(Math.random()*2-1)*0.7, (Math.random()*2-1)*4, 0);
    }
    /* the curve itself, sampled evenly ALONG ITS ARC so the tight ends are
       as well covered as the flat middle - no break at the bottom         */
    var m=Math.round(180*F);
    for(var j=0;j<m;j++){
      var ps=(j+Math.random()*0.6)/m*(Math.PI/2);
      var r2=127*Math.cos(ps), t2=0.980+0.020*Math.sin(ps), sd2=(j&1)?1:-1;
      put(sd2*r2+(Math.random()*2-1)*0.7, t2*VHT+(Math.random()*2-1)*0.7, (Math.random()*2-1)*4, 0);
    }
    /* a little depth so the base does not read as a bare line */
    var k2=Math.round(60*F);
    for(var k=0;k<k2;k++){
      var t3=0.972+Math.random()*0.028, r3=halfW(t3), th=Math.random()*Math.PI*2;
      put(Math.cos(th)*r3*(0.55+Math.random()*0.45), t3*VHT, Math.sin(th)*r3, 0);
    }
  })();
  /* ---------- 8. black lid: flat top, rounded sides, darkest ---------- */
  flat(0.009, 120, 0, 134, 0.6, 4);
  wrap(0.016, 0.086, 160, 0.8, 4);
  side(0.014, 0.090, 234, 4, 5);       /* the two side air pockets */
  fill(0.014, 0.090, 206, 4);
  /* ---------- 7. silver-to-black separator ---------- */
  rule(0.0955, 120, 5);
  /* ---------- 6. silver cap band: lighter, moderately filled ---------- */
  wrap(0.106, 0.187, 38, 0.9, 1);
  side(0.106, 0.187, 56, 1, 6);        /* even across the sides too */
  fill(0.106, 0.187, 72, 1);
  /* ---------- 5. glass-to-silver separator ---------- */
  rule(0.1965, 120, 5);
  /* ---------- 4. glass neck + rounded shoulder ---------- */
  wrap(0.206, 0.292, 52, 1.3, 2);
  side(0.206, 0.292, 48, 2, 7);         /* neck flanks */
  wrap(0.298, 0.370, 55, 1.2, 2);
  side(0.298, 0.370, 60, 2, 7);         /* the two shoulder pockets */
  /* ---------- 2. clear-glass interior: light, even, transparent ---------- */
  wrap(0.372, PWD-0.008, 150, 1.5, 2);
  side(0.372, PWD-0.008, 95, 2, 7);  /* no empty band beside the glass */
  fill(0.376, PWD-0.006, 140, 2);
  /* ---------- 3. powder: level bed, evenly spread ---------- */
  /* the powder line itself: a full-width ring at the fill height, so it
     reads as one clean level line that runs all the way into the glass
     contour on BOTH flanks with no gap at either end                     */
  rule(PWD, 78, 3);
  flat(PWD+0.002, 128, 0, halfW(PWD)*0.995, 1.4, 3);
  wrap(PWD, PWD+0.014, 40, 0.9, 3);
  side(PWD+0.008, 0.966, 264, 3, 5);  /* closes the gaps, same extent */
  fill(PWD+0.010, 0.968, 620, 3);
  /* ---------- floating halo: a true ring, so the slow orbit keeps the
     same clear gap from the silhouette at every moment of the loop.
     The vial's furthest point from its own centre is 362 units (top and
     bottom centre); the ring starts at 420, i.e. a visible gap all round. */
  (function(){
    var n=Math.round(150*F), R0=420, R1=505;
    for(var i=0;i<n;i++){
      var th=(i+Math.random())/n*Math.PI*2;
      var rr=R0+(R1-R0)*Math.pow(Math.random(),1.6);
      put(Math.cos(th)*rr, Math.sin(th)*rr + VHT/2, (Math.random()*2-1)*46, 6);
    }
  })();
  return P;
}
/* Reach the particle budget by scaling every layer together, so the tonal
   ratio between lid, band, glass and powder is exactly as authored. */
function buildVial(){
  var p=genVial(1);
  if(p.length>=N) return p;
  var p2=genVial(N/Math.max(1,p.length)*1.04);
  return p2.length>=p.length ? p2 : p;
}
/* ---------------- COA document geometry ---------------- */
function genCOA(){
  var P=[], DW=520, DH=DW/0.72;                    /* portrait document */
  function put(x,y,z){
    if(x<0)x=0; if(x>DW)x=DW; if(y<0)y=0; if(y>DH)y=DH;   /* no overspray */
    P.push([x-DW/2, y-DH/2, (z===undefined?(Math.random()*2-1)*3.2:z)]);
  }
  function line(x1,y1,x2,y2,step){
    var d=Math.hypot(x2-x1,y2-y1), n=Math.max(2,Math.round(d/(step||3.2)));
    for(var i=0;i<=n;i++){
      var u=i/n;
      put(x1+(x2-x1)*u+(Math.random()*2-1)*0.8, y1+(y2-y1)*u+(Math.random()*2-1)*0.8, (Math.random()*2-1)*1.6);
    }
  }
  /* border - right edge and corners carry extra density */
  line(0,0,DW,0,2.6); line(DW,0,DW,DH,1.7); line(DW,DH,0,DH,2.6); line(0,0,0,DH,2.4);
  [[0,0],[DW,0],[DW,DH],[0,DH]].forEach(function(c){
    for(var i=0;i<30;i++){
      var ang=Math.random()*Math.PI*2, rr=Math.random()*7;
      put(c[0]+Math.cos(ang)*rr, c[1]+Math.sin(ang)*rr, (Math.random()*2-1)*1.4);
    }
  });
  /* header band */
  line(0,96,DW,96,3.0);
  for(var i=0;i<150;i++) put(Math.random()*DW, Math.random()*96);
  /* title + label rules */
  line(46,150,300,150,3.4); line(46,176,210,176,3.6);
  /* data rules - evenly spaced */
  var y=228;
  for(var r=0;r<7;r++){
    var w=DW*(0.36+Math.random()*0.40);
    line(46,y,46+w,y,3.4);
    y+=31;
  }
  /* table block - evenly spaced grid, clear of the trace below */
  var ty=452, tw=DW-92, rows=5, rowH=30, cols=4;
  for(var rr=0;rr<=rows;rr++) line(46,ty+rr*rowH,46+tw,ty+rr*rowH,3.8);
  for(var cc=0;cc<=cols;cc++){            /* inset so ends don't double up */
    var vx2=46+cc*(tw/cols);
    line(vx2, ty+3, vx2, ty+rows*rowH-3, 4.0);
  }
  /* chromatogram trace - sits below the table with clear separation */
  var cy=690, cw=DW-92;                    /* straight, continuous rule */
  line(46,cy,46+cw,cy,3.0);
  /* fill remainder with faint field inside the sheet */
  var guard=0;                                   /* blank areas stay sparse */
  while(P.length<N*0.995 && guard<90000){
    guard++;
    put(20+Math.random()*(DW-40), 20+Math.random()*(DH-40), (Math.random()*2-1)*2.2);
  }
  return P;
}
/* ---------------- resample + angular sort ---------------- */
function resample(P,n){
  var out=[];
  if(P.length>=n){
    var step=P.length/n;
    for(var i=0;i<n;i++) out.push(P[Math.floor(i*step)]);
  } else {
    for(var j=0;j<n;j++) out.push(P[j%P.length]);
  }
  return out;
}
function angSort(P){
  return P.slice().sort(function(a,b){
    var aa=Math.atan2(a[1],a[0]), bb=Math.atan2(b[1],b[0]);
    if(aa===bb) return (a[0]*a[0]+a[1]*a[1])-(b[0]*b[0]+b[1]*b[1]);
    return aa-bb;
  });
}
var VIAL=angSort(resample(buildVial(),N));
var COA =angSort(resample(genCOA(), N));
/* ---------------- particles ---------------- */
var P=[];
for(var i=0;i<N;i++){
  var yn=(VIAL[i][1]+VHT/2)/VHT;                    /* 0 top .. 1 base of vial */
  P.push({
    vx:VIAL[i][0], vy:VIAL[i][1], vz:VIAL[i][2]||0,
    rg:(VIAL[i][3]===undefined?2:VIAL[i][3]),
    cx:COA[i][0],  cy:COA[i][1],  cz:COA[i][2]||0,
    hx:0, hy:0, hz:0,                               /* halo, set in layout() */
    d: Math.min(0.999, Math.max(0, yn*0.72 + Math.random()*0.26)), /* stagger: top peels first */
    ph: Math.random()*6.2831,
    sp: 0.18+Math.random()*0.42,
    orb: (0.7+Math.random()*2.6)*PS,      /* drift scales with the stage */
    z: 0.50+Math.random()*0.95,
    ax:Math.random()*6.2831, ay:Math.random()*6.2831, az:Math.random()*6.2831,
    r1:(Math.random()*2-1)*0.55, r2:(Math.random()*2-1)*0.62, r3:(Math.random()*2-1)*0.38,
    si: (Math.random()*SZ.length)|0,
    al: 0.82+Math.random()*0.18,
    bow: (Math.random()*2-1)
  });
  var q=P[P.length-1];
  /* region shade: lid & outline darkest, powder dark, silver mid, glass light */
  q.dk = (q.rg===2||q.rg===6) ? 2 : (q.rg===1 ? 1 : 0);  /* glass+halo 2, silver 1 */
  /* outline (0) and separator rules (5) stay crisp rather than heavy;
     the halo stays the faintest thing on screen.                       */
  q.szb = q.rg===6 ? 1.00 : (q.rg===2 ? 0.84 : (q.rg===1 ? 0.90 :
          (q.rg===0 ? 0.82 : (q.rg===5 ? 0.80 : 1.0))));
  q.cap = (q.rg===1||q.rg===4||q.rg===5) ? 1 : 0;  /* cap zones stay fixed */
  q.sh = q.dk;
}
/* ---------------- layout ---------------- */
var dpr=1, vw=0, vh=0, SH=0;
var V={x:0,y:0,s:1,rot:40*Math.PI/180}, SAFE=null;
/* THE canonical baseline for every scene: the vial's framing and the
   document's framing, derived only from the viewport and the locked
   stage height. It is rebuilt in layout() and nowhere else, and every
   scene entry copies FROM it - values are never edited in place, so no
   transform, scale or offset from another scene can ever accumulate.  */
var BASE=null;
function computeBaseline(){
  BASE={
    vs:(MB ? SH*0.42 : SH*0.76)/VHT,
    vx: MB ? vw*0.5  : vw*0.71,
    vy: MB ? SH*0.31 : SH*0.52,
    cs:(MB ? SH*0.40 : SH*0.68)/(520/0.72),
    cx: MB ? vw*0.5  : vw*0.70,
    cy: MB ? SH*0.27 : SH*0.50
  };
}
function applyBaseline(){
  if(!BASE) computeBaseline();
  V.s=BASE.vs; V.x=BASE.vx; V.y=BASE.vy;      /* fresh copy of the baseline */
  C.s=BASE.cs; C.x=BASE.cx; C.y=BASE.cy;
}
var HB=document.querySelector('#vph1 .vph-in');
/* The Scene-1 copy guard, re-measured from the live copy block. It used to
   be captured once during layout(); if that happened while the page was
   scrolled - a refresh part-way down, a resize at another stage - the
   protected zone was stored in the wrong place and orbit particles could
   sit on the text. Taking it fresh means it is correct on load, after any
   stage change, after a reverse scroll, a snap, a refresh and a resize.
   It spans the whole copy block: eyebrow, headline, paragraph and button. */
var safeAt=-1;
function refreshSafe(force){
  if(!HB){ SAFE=null; return; }
  /* the copy block only moves when the page does, so re-read it only then */
  if(!force && SAFE && safeAt===SY0) return;
  safeAt=SY0;
  var hr=HB.getBoundingClientRect(), p1=scene1Shift(SY0);
  SAFE={l:hr.left-10, t:hr.top-10-p1, r:hr.right+10, b:hr.bottom+10-p1};
}
var C={x:0,y:0,s:1};
/* ---- Stage 3 wrapper latch -------------------------------------------
   coaLk goes up the instant the Stage 2 -> Stage 3 transition completes
   and stays up through the whole of Stage 3 and all the way down to the
   footer, holding the COA wrapper's final composition. It comes down only
   when the reader has genuinely scrolled back INTO that transition, which
   is the one and only moment the wrapper is allowed to travel again.    */
var coaLk=0, coaHY=0;
/* SH is the height the SCENE is laid out against. On a phone innerHeight
   changes every time the browser chrome hides or reveals during a scroll;
   feeding that straight into the scale made the vial and the COA visibly
   grow and shrink mid-scroll. SH therefore holds the first measured height
   and only moves on a real orientation change, so the scene keeps one
   stable coordinate system while the canvas still fills the real viewport.
   On desktop SH is always exactly innerHeight, so nothing there changes.  */
var SHW=0, SHO=-1;               /* the width and orientation SH belongs to */
function stableHeight(){
  if(!MB){ SHW=vw; SHO=-1; return vh; }
  var o = vw>vh ? 1 : 0;
  /* Re-baseline ONLY on a real orientation change. A phone's browser
     chrome sliding away changes innerHeight, and several browsers nudge
     innerWidth by a pixel or two at the same moment. Treating that as a
     new layout rescaled the whole scene mid-journey - which is exactly
     why the vial came back larger and lower after visiting Scene 2 or 3
     and returning. The baseline the visitor first saw is now kept.    */
  if(!SH || o!==SHO || Math.abs(vw-SHW) > SHW*0.25){ SHW=vw; SHO=o; return vh; }
  return SH;
}
function layout(){
  vw=innerWidth; vh=innerHeight;
  MB=vw<750;
  SH=stableHeight();
  /* phones fill far fewer device pixels per frame - the visual is the same
     scaled scene, just less rasteriser work, which is what keeps it smooth */
  dpr=Math.min(devicePixelRatio||1, vw<750 ? 1.75 : 2);
  cv.width=Math.round(vw*dpr); cv.height=Math.round(vh*dpr);
  if(SEC1) S1H=SEC1.getBoundingClientRect().height;   /* only changes on resize */
  if(SEC3) S3H=SEC3.getBoundingClientRect().height;
  computeBaseline();
  applyBaseline();
  coaLk=0;            /* the geometry moved: re-latch from the new baseline */
  /* Scene-1 copy guard: the orbiting halo fades out before it can reach
     the hero copy, whatever the viewport - beside it on desktop, above it
     on mobile. Measured off the copy block itself at its panel's rest
     position, then shifted each frame by exactly the same scroll
     translation the vial gets, so the two can never drift apart.         */
  measure();
  refreshSafe(1);
  /* halo: annulus sized off scene-2 text box so copy is never crossed */
  var box=document.querySelector('#vph2 .vph-in');
  var rin = 340;
  if(box){ var r=box.getBoundingClientRect(); rin=Math.hypot(r.width,r.height)/2 + (MB?38:70); }
  var rout=Math.hypot(vw,SH)*0.46;
  if(rin>rout*0.72) rin=rout*0.72;
  /* Each particle's place in the ring - its angle, its radial position and
     its depth - is decided ONCE, at start-up, and kept. Only the ring's
     measurements are recomputed here. Re-rolling them on every layout()
     meant any resize (a phone's chrome sliding away fires one) reshuffled
     the whole Scene 2 field around the copy, which read as the text
     drifting into the pyramids on the way back.                        */
  for(var i=0;i<N;i++){
    var p=P[i];
    if(p.ha===undefined){
      p.ha=(i/N)*Math.PI*2 + (Math.random()-0.5)*0.05;
      p.hu=Math.pow(Math.random(),1.7);
      p.hd=(Math.random()*2-1)*95;
    }
    var rr=rin+(rout-rin)*p.hu;
    p.hx=vw*0.5+Math.cos(p.ha)*rr*1.12;
    p.hy=SH*0.5+Math.sin(p.ha)*rr*0.92;
    p.hz=p.hd;
  }
}
/* ---------------- scroll ---------------- */
var prog=0, tail=1, headY=0, TICK=0, FOOTV=0;
var SEC1=document.querySelector('#vph1');
var T2IN=document.querySelector('#vph2 .vph-in');
var PIN1=document.querySelector('#vph1 .vph-pin');
/* Exactly the translation the Scene-1 copy block is under at this scroll
   position: its panel's current viewport top, minus where that panel sits
   at rest. Feeding this to the vial makes copy and vial one composition -
   they rise together, pixel for pixel, from the first scroll onward.     */
/* Derived from scrollY ARITHMETICALLY rather than by reading the sticky
   panel's rect. A sticky element and a position:fixed canvas are painted
   by different compositor paths, so on phones their reported positions
   disagree by a pixel or two during momentum scrolling - that disagreement
   was the vial jitter. This reproduces the panel's translation exactly
   while staying perfectly smooth.                                        */
var S1TOP=0, S1H=0, S3TOP=0, S3H=0;      /* section tops in page coords, heights */
/* One shared, purely arithmetic model of where a sticky scene panel sits.
   Nothing here reads a sticky element's box, so the particle scene can
   never pick up a second, disagreeing copy of the page's scroll state. */
function panelTopOf(top,h,sy){
  var raw=top-sy, rel=(top+h-SH)-sy;
  return raw>0 ? raw : (rel<0 ? rel : 0);
}
function scene1Shift(sy){
  /* Desktop only: the hero copy and the vial ride up together as one
     composition. On a phone each scene owns ONE coordinate system and the
     vial is anchored to its own stage - it takes no page-scroll transform
     at all, so it cannot drag, stretch or lag behind a swipe.            */
  if(MB || !SEC1) return 0;
  return panelTopOf(S1TOP,S1H,sy)-S1TOP;  /* 0 at rest, negative as it rises */
}
var SEC3=document.querySelector('#vph3');
var PIN3=document.querySelector('#vph3 .vph-pin');
function headerBottom(){
  var h=document.querySelector('[id*="header_section"], header');
  if(!h) return 0;
  var r=h.getBoundingClientRect();
  return r.top<=1 ? Math.max(0,r.bottom) : 0;   /* only when stuck to the top */
}
/* Every scroll-driven value is read ONCE PER ANIMATION FRAME, from the top
   of computeFrame - never per scroll event. On phones a flick can fire
   scroll events several times between paints; measuring on each of them
   both wasted layout passes and let the scene sample the page at instants
   that were never drawn, which read as stutter.                          */
var SY0=0, WTOT=1;
/* The render clock. On mobile a stage change tweens this from wherever
   the pyramids currently are to the next scene's value over MORPH_MS,
   independently of how quickly the page itself settles - so the page can
   arrive promptly while the SAME pyramids are still visibly travelling
   and re-forming. Nothing about the choreography changes; only the clock
   that drives it is given a readable duration.                        */
var pView=0, tPrev=null;
var mvOn=0, mvFrom=0, mvTo=0, mvT=0, MORPH_MS=1250;
function measure(){
  SY0 = window.pageYOffset||document.documentElement.scrollTop||0;
  var r=W.getBoundingClientRect();               /* the only read Scene 1 needs */
  /* SH, not innerHeight: on a phone innerHeight moves with the browser
     chrome, and using it here made progress - and therefore the whole
     scene - jump every time the chrome slid away mid-scroll.            */
  WTOT = r.height-SH;
  prog = WTOT>0 ? Math.min(1,Math.max(0, -r.top/WTOT)) : 0;
  tail = r.top>0 ? Math.max(0,1-(r.top/SH)) : 1;   /* COA never fades out  */
  S1TOP = r.top + SY0;
  S3TOP = S1TOP + (SEC3 ? SEC3.offsetTop - (SEC1?SEC1.offsetTop:0) : 0);
  /* Everything below .vph is the footer, so the moment .vph's bottom edge
     rises above the bottom of the screen some footer is on show. Measured
     against the REAL innerHeight, because this is about what the visitor
     can actually see, not about the locked stage height.               */
  FOOTV = r.bottom < (window.innerHeight||SH) - 1 ? 1 : 0;
  /* the footer marker and the header only matter once the COA is in play */
  if(prog>0.45) headY = headerBottom();
}
/* fresh read for the event handlers, which run outside the frame loop */
function footerShown(){
  return W.getBoundingClientRect().bottom < (window.innerHeight||SH) - 1;
}
function onScroll(){ if(!TICK) TICK=1; }
/* ---------------- easing ---------------- */
var SR=366/290;                    /* old scroll range / new scroll range */
/* The Stage 2 -> Stage 3 transition, in page progress. E2B is the exact
   point at which the COA wrapper finishes: at and beyond it the wrapper is
   done and stays done; below it, and only below it, may it travel back
   toward Stage 2. Both the render latch and the mobile stage controller
   read the SAME number, so the visual state and the scroll behaviour can
   never disagree about where the transition ends.                       */
var E2A=0.4766*SR, E2B=0.7190*SR;
function ss(a,b,x){ var t=Math.min(1,Math.max(0,(x-a)/(b-a))); return t*t*(3-2*t); }
function eio(t){ return t<0.5 ? 4*t*t*t : 1-Math.pow(-2*t+2,3)/2; }
var EASE = (MB && !RM) ? function(t){ return t; } : eio;
/* scene text opacity */
var T1=document.querySelector('#vph1 .vph-tx'),
    T2=document.querySelector('#vph2 .vph-tx'),
    T3=document.querySelector('#vph3 .vph-tx');
/* ---------------- render ---------------- */
var mx=0,my=0,tmx=0,tmy=0;
if(!MB){
  addEventListener('pointermove',function(e){
    tmx=(e.clientX/innerWidth-0.5)*2; tmy=(e.clientY/innerHeight-0.5)*2;
  },{passive:true});
}
var SX=new Float32Array(N), SY=new Float32Array(N), SA=new Float32Array(N), SK=new Float32Array(N), SZW=new Float32Array(N);
/* Per-particle projection-depth weight. 0 = flat / orthographic (Scene 1:
   camera dead level and square to the vial's front face), 1 = the original
   perspective divide used by Scenes 2 and 3. Depth still drives shading and
   size at full strength either way, so the tetrahedra keep their 3D read.   */
var SPZ=new Float32Array(N);
var SV=new Uint8Array(N);
var t0=null;
function computeFrame(ts){
  if(t0===null) t0=ts;
  var el=(ts-t0)/1000;
  var dt=(tPrev===null?16:Math.min(64,ts-tPrev))/1000; tPrev=ts;
  measure(); TICK=0;              /* one sample of the page, once a frame */
  if(prog<0.34) refreshSafe();    /* Scene 1 on screen: keep the guard live */
  dragApply();                    /* the single scroll write of this frame */
  footerWatch();                  /* the upward-only catch at Scene 3       */
  /* Mobile only: what the pyramids render against trails the page's own
     progress through a short critically-damped follow. The stage lock can
     therefore land the page on the next scene promptly while the SAME
     pyramids visibly travel and turn into their new arrangement over
     about three quarters of a second, instead of snapping there. The
     choreography is untouched - only the clock driving it is eased.    */
  if(MB && !RM){
    if(mvOn){
      mvT += dt*1000;
      /* LINEAR in scene progress. The choreography already carries its own
         easing; adding a second ease on top ran the clock at double speed
         through exactly the stretch where the pyramids do all their
         travelling, which is what made the morph look like a jump.     */
      var u=Math.min(1,mvT/MORPH_MS);
      pView = mvFrom + (mvTo-mvFrom)*u;
      if(u>=1){
        mvOn=0; morphBusy=0; pView=prog;
        /* settling was held off while the pyramids were arriving; if a
           nudge left the page slightly off an anchor in the meantime,
           tidy it now that the transition is genuinely finished.      */
        if(!drag && !scrollBusy) settleNearest();
      }
    } else {
      /* not transitioning: follow the page directly so a finger drag
         still moves the pyramids live under the thumb                */
      pView = prog;
    }
  } else pView=prog;
  var p=pView;
  /* While the upward catch is absorbing a fling, the scene is pinned to
     Scene 3's own value. A hard flick can cover hundreds of pixels between
     two frames, and without this the COA and the Scene 3 copy would show
     one frame of the transition running backwards before the catch pulled
     the page back down. Nothing else is affected: the pyramids' own idle
     rotation and float run off the render clock, not off p.            */
  if(upCatch && p<SNAP[LAST]) p=SNAP[LAST];
  /* Scene text. The cue values below are the approved ones, expressed
     against the ORIGINAL scroll range; SR rescales them for the shorter
     range left after the dead run past the COA landing was removed
     (130+130+190+16 - 100 = 366vh of travel, now 130+130+130+0 - 100 =
     290vh). Every cue therefore still fires at the same absolute scroll
     distance down the page as it did before.                            */
  var t2op = ss(0.3010*SR,0.3679*SR,p)*(1-ss(0.4222*SR,0.4891*SR,p));
  if(T1) T1.style.opacity = (1-ss(0.1421*SR,0.2341*SR,p)).toFixed(3);
  if(T2) T2.style.opacity = t2op.toFixed(3);
  if(T3) T3.style.opacity = (ss(0.6605*SR,0.7357*SR,p)).toFixed(3);
  /* Morph phases. Desktop keeps the approved cubic-in-out on top of the
     smoothstep. On mobile that composite peaks at well over twice the
     average rate, which crushed the whole transformation into a tenth of
     a second and read as a jump; there the smoothstep alone paces it.
     The particles travel exactly the same paths either way - only the
     speed along them is evened out.                                    */
  var e1=EASE(ss(0.1589*SR,0.3846*SR,p));   /* vial  -> halo */
  var e2=EASE(ss(E2A,E2B,p));               /* halo  -> doc  */
  mx+=(tmx-mx)*0.05; my+=(tmy-my)*0.05;
  /* ---- Stage 3: the COA wrapper is finished, and stays finished -------
     The outer wrapper is allowed to animate across the Stage 2 -> Stage 3
     transition and nowhere else. The instant that transition completes,
     its final composition is latched - including the header clamp, frozen
     at the value it had at that moment - so nothing the page does
     afterwards can re-run, re-scale or nudge it: not a sticky header
     appearing or leaving, not the footer arriving, not a momentum flick.
     From there to the footer the wrapper only ever rides with its own
     section, one to one with the page, which is ordinary scrolling and
     never an animation of its own. The latch is released only when the
     reader is genuinely back inside the transition (e2 below 1), which is
     the one moment the wrapper may travel toward Stage 2 again.
     None of this touches the individual prisms: their idle rotation and
     float run off the render clock and continue exactly as before.     */
  var docH=(520/0.72)*C.s, pad=MB?26:44;
  if(e2>=0.9999){ if(!coaLk){ coaLk=1; coaHY=headY; } }
  else coaLk=0;
  var hY = coaLk ? coaHY : headY;
  /* Same arithmetic model on phones, so the COA is driven by exactly one
     scroll value and never by a sticky box the compositor reports late. */
  var pinOff = e2<=0 ? 0
             : (MB ? Math.min(0, panelTopOf(S3TOP,S3H,SY0))
                   : (PIN3 ? Math.min(0, PIN3.getBoundingClientRect().top) : 0));
  var cyClamped = C.y + pinOff;
  var minCy = hY + pad + docH/2;                   /* never under the header */
  if(cyClamped < minCy && pinOff===0) cyClamped = minCy;
  SV.fill(0);
  if(tail<=0.001) return -1;
  /* Scene 1 is ONE composition: the hero copy and the vial share a single
     scroll translation. This is the very same offset the copy block gets
     from its own panel, so the two can never drift apart by a pixel and
     the vial is never left pinned while the text rides up.               */
  /* Phones only: the Scene-2 copy group gets its own protected area. The
     guard's strength IS the copy's own opacity, so it ramps in and out
     with the text and has no effect at all in Scenes 1 and 3 - and none
     anywhere on desktop, where MB is false.                              */
  var S2B = (MB && T2IN && t2op>0.004) ? T2IN.getBoundingClientRect() : null;
  var sc1Off = scene1Shift(SY0);
  var vY = V.y + sc1Off;
  var sTop = SAFE ? SAFE.t + sc1Off : 0, sBot = SAFE ? SAFE.b + sc1Off : 0;
  var cosR=Math.cos(V.rot), sinR=Math.sin(V.rot);
  /* Detached halo only: one very slow counter-clockwise revolution about
     the vial's own centre (~96s per loop). The vial itself never moves.  */
  var hA = RM ? 0 : -el*0.0654;
  var cosH=Math.cos(hA), sinH=Math.sin(hA);
  for(var i=0;i<N;i++){
    var q=P[i];
    /* staggered local progress */
    var s1=Math.min(1,Math.max(0,(e1-q.d*0.34)/(1-0.34)));
    var s2=Math.min(1,Math.max(0,(e2-(1-q.d)*0.30)/(1-0.30)));
    /* vial point -> screen (rotated 40deg) */
    /* ONE in-plane Z rotation for the whole assembled vial. Camera stays
       level and square to the front face - no pitch, no yaw. Every layer
       (lid, band, neck, body, powder, outline, halo) shares it exactly.  */
    var lvx=q.vx, lvy=q.vy;
    if(q.rg===6){ var lt=lvx*cosH - lvy*sinH; lvy=lvx*sinH + lvy*cosH; lvx=lt; }
    var vxr=(lvx*cosR - lvy*sinR)*V.s + V.x;
    var vyr=(lvx*sinR + lvy*cosR)*V.s + vY;
    var vzr=q.vz*V.s;
    /* doc point -> screen */
    var cxs=q.cx*C.s + C.x;
    var cys=q.cy*C.s + cyClamped;
    var czs=q.cz*C.s;
    /* vial -> halo along an arc */
    var ax,ay;
    if(s1<=0){ ax=vxr; ay=vyr; }
    else{
      var mxp=(vxr+q.hx)/2, myp=(vyr+q.hy)/2;
      var ndx=-(q.hy-vyr), ndy=(q.hx-vxr), nl=Math.hypot(ndx,ndy)||1;
      var bow=q.bow*Math.min(220,nl*0.28);
      mxp+=ndx/nl*bow; myp+=ndy/nl*bow;
      var u=s1, iu=1-u;
      ax=iu*iu*vxr + 2*iu*u*mxp + u*u*q.hx;
      ay=iu*iu*vyr + 2*iu*u*myp + u*u*q.hy;
    }
    /* halo -> doc along an arc */
    var x,y;
    if(s2<=0){ x=ax; y=ay; }
    else{
      var mx2=(ax+cxs)/2, my2=(ay+cys)/2;
      var d2x=-(cys-ay), d2y=(cxs-ax), l2=Math.hypot(d2x,d2y)||1;
      var bow2=-q.bow*Math.min(180,l2*0.20);
      mx2+=d2x/l2*bow2; my2+=d2y/l2*bow2;
      var u2=s2, iu2=1-u2;
      x=iu2*iu2*ax + 2*iu2*u2*mx2 + u2*u2*cxs;
      y=iu2*iu2*ay + 2*iu2*u2*my2 + u2*u2*cys;
    }
    /* depth follows the same two-stage morph */
    var zA = s1<=0 ? vzr : (vzr+(q.hz-vzr)*s1);
    var zw = s2<=0 ? zA  : (zA+(czs-zA)*s2);
    var ox0=x, oy0=y;          /* smooth path, before drift and parallax */
    /* drift + parallax */
    if(!RM){
      var amp=q.orb*(1+2.6*s1*(1-s2))*(1-s2);
      x+=Math.cos(el*q.sp+q.ph)*amp;
      y+=Math.sin(el*q.sp*0.83+q.ph*1.27)*amp;
    }
    x+=mx*q.z*9; y+=my*q.z*6;
    if(!RM) zw+=Math.sin(el*q.sp*0.7+q.ph)*q.orb*0.6;
    if(x<-110||x>vw+110||y<-110||y>vh+110) continue;
    var a=q.al;
    if(!RM) a*=0.92+0.08*Math.sin(el*(0.6+q.sp)+q.ph);
    var halo=s1*(1-s2);
    a*=0.84+0.16*(1-Math.abs(s1-s2));
    /* Orbit particles never pop. They keep orbiting on exactly the same
       path at exactly the same speed the whole way round; only their
       opacity eases - out over 170px before they reach the copy, back in
       over the same 170px once they are clear of it again.               */
    /* Mobile Scene 2: any pyramid that reaches the copy group eases its
       opacity to zero before it can touch a letter, keeps travelling on
       exactly the same path while invisible, and eases back in on the
       far side. Nothing about its motion or position changes.           */
    if(S2B){
      var bx=Math.max(S2B.left-10-x, x-(S2B.right+10), 0);
      var by=Math.max(S2B.top-10-y, y-(S2B.bottom+10), 0);
      var bd=Math.sqrt(bx*bx+by*by);
      if(bd<86){ var bu=bd/86; a *= 1-(1-bu*bu*(3-2*bu))*t2op; }
    }
    if(q.rg===6){
      /* measured from the SMOOTH orbit position, never the jittered one,
         so the ramp is monotonic in time and cannot flicker              */
      if(s1<0.5 && SAFE){
        var gx=Math.max(SAFE.l-ox0, ox0-SAFE.r, 0), gy=Math.max(sTop-oy0, oy0-sBot, 0);
        var gd=Math.sqrt(gx*gx+gy*gy);          /* 0 anywhere over the copy */
        if(gd<170){ var gu=gd/170; a *= gu*gu*(3-2*gu); }
      }
      /* and the same easing at the frame edge, so an orbit particle
         leaving the viewport dissolves instead of being clipped away    */
      var ed=Math.min(x+70, vw+70-x, y+70, vh+70-y);
      if(ed<90){ var eu=ed<0?0:ed/90; a *= eu*eu*(3-2*eu); }
    }
    if(a<=0.02) continue;
    var k=q.z*(1+0.30*halo);
    a*=tail;   /* same ink as desktop: the mobile stage is a scaled copy */
    /* Flat while the vial is assembled; the original perspective returns as
       the particle leaves for the halo, so Scenes 2/3 project exactly as
       they did before.                                                     */
    var pzf = s1>=0.55 ? 1 : (s1<=0 ? 0 : (function(u){return u*u*(3-2*u);})(s1/0.55));
    SX[i]=x; SY[i]=y; SA[i]=a>0.97?0.97:a; SK[i]=k; SZW[i]=zw; SPZ[i]=pzf; SV[i]=1;
    var shD = zw>44 ? 0 : (zw>-38 ? 1 : 2);
    if(s1<0.45){                                   /* vial intact: region rules */
      if(q.cap) q.sh=q.dk;                         /* cap layers never blend    */
      else { var mixed=q.dk*0.72+shD*0.28; q.sh = mixed<0.5?0:(mixed<1.5?1:2); }
    } else q.sh = shD;
  }
  return el;
}
/* ---------------- 2D software-3D renderer ---------------- */
function frame2D(ts){
  requestAnimationFrame(frame2D);
  var el=computeFrame(ts);
  g.setTransform(dpr,0,0,dpr,0,0);
  g.clearRect(0,0,vw,vh);
  if(el<0) return;
  for(var band=2;band>=0;band--){
    for(var j=0;j<N;j++){
      if(!SV[j]) continue;
      var qq=P[j]; if(qq.sh!==band) continue;
      shard(qq, SX[j], SY[j], SA[j], SK[j], SZW[j], el, SPZ[j]);
    }
  }
}
/* ---------------- one 3D shard ---------------- */
var RM3=[0,0,0,0,0,0,0,0,0];
var PX=[0,0,0,0,0,0], PY=[0,0,0,0,0,0], WZ=[0,0,0,0,0,0];
function shard(q,cx,cy,a,k,zc,el,pz){
  var t = RM ? 0 : el;
  var A=q.ax+t*q.r1, B=q.ay+t*q.r2, C2=q.az+t*q.r3;
  var ca=Math.cos(A), sa=Math.sin(A), cb=Math.cos(B), sb=Math.sin(B), cc=Math.cos(C2), sc2=Math.sin(C2);
  /* R = Rz * Ry * Rx */
  RM3[0]=cc*cb;               RM3[1]=cc*sb*sa-sc2*ca;     RM3[2]=cc*sb*ca+sc2*sa;
  RM3[3]=sc2*cb;              RM3[4]=sc2*sb*sa+cc*ca;     RM3[5]=sc2*sb*ca-cc*sa;
  RM3[6]=-sb;                 RM3[7]=cb*sa;               RM3[8]=cb*ca;
  var sz=SZ[q.si]*k*1.02*(q.szb||1);
  var ox=cx-vw/2, oy=cy-vh/2;
  for(var v=0;v<4;v++){
    var L=LV[v];
    var wx=(RM3[0]*L[0]+RM3[1]*L[1]+RM3[2]*L[2])*sz;
    var wy=(RM3[3]*L[0]+RM3[4]*L[1]+RM3[5]*L[2])*sz;
    var wz=(RM3[6]*L[0]+RM3[7]*L[1]+RM3[8]*L[2])*sz + zc;
    var pp=CAMD/(CAMD-wz*pz);                  /* perspective divide, scoped */
    PX[v]=vw/2+(ox+wx)*pp; PY[v]=vh/2+(oy+wy)*pp; WZ[v]=wz;
  }
  var alb=ALB[q.sh];
  g.globalAlpha=a;
  for(var f=0;f<4;f++){        /* tetrahedron: backface culling picks visible faces */
    var F=FC[f], n=F.length;
    /* newell normal in screen-ish space (z from world) */
    var nx=0,ny=0,nz=0;
    for(var e=0;e<n;e++){
      var i0=F[e], i1=F[(e+1)%n];
      var x0=PX[i0]-vw/2, y0=PY[i0]-vh/2, z0=WZ[i0];
      var x1=PX[i1]-vw/2, y1=PY[i1]-vh/2, z1=WZ[i1];
      nx+=(y0-y1)*(z0+z1); ny+=(z0-z1)*(x0+x1); nz+=(x0-x1)*(y0+y1);
    }
    var nl=Math.hypot(nx,ny,nz)||1; nx/=nl; ny/=nl; nz/=nl;
    if(nz<=0) continue;                        /* backface cull            */
    var nd=nx*LGT[0]+ny*LGT[1]+nz*LGT[2]; if(nd<0) nd=0;
    var lum=alb*(AMB+DIF*nd);
    var v255=(lum*255)|0; if(v255>255)v255=255;
    g.fillStyle='rgb('+v255+','+v255+','+v255+')';
    g.beginPath(); g.moveTo(PX[F[0]],PY[F[0]]);
    for(var e2=1;e2<n;e2++) g.lineTo(PX[F[e2]],PY[F[e2]]);
    g.closePath(); g.fill();
  }
}
/* ---------------- mobile stage lock ----------------
   A small explicit state machine, and the ONLY thing that moves the page
   on a phone - there is no CSS scroll-snap and no second settler that
   could issue a competing command.
     curStage   the last stage the page actually settled on
     target     the destination a swipe has committed to (-1 = none)
     scrollBusy the page is travelling to target; nothing may retarget it
     morphBusy  the pyramids are still arriving; settling stays disabled
   A swipe past the threshold picks ONE adjacent stage from curStage and
   commits to it. Nothing after that re-derives a stage from the in-between
   scroll position, which is what used to drag the page back to where the
   swipe started.
   Scene 3 is DIRECTIONAL. Downward it is the last stage: the run from its
   rest position to the footer is ordinary reading and the controller never
   touches it. Upward it is a stop: the return out of the footer is caught
   at Scene 3's own anchor, whatever momentum is behind it, and the reader
   must deliberately continue upward to go on to Scene 2.               */
var SNAP=[0, 0.4986, 0.9285];          /* Scene 1 / Scene 2 / Scene 3 rest */
var LAST=SNAP.length-1;
var curStage=0, target=-1, scrollBusy=0, morphBusy=0, freed=0;
var snapT=null, snapRAF=null, drag=0;
var tPrevY=0, tAccum=0, lastSY=0, dirDown=1, burst=0;
function geom(){
  var r=W.getBoundingClientRect();
  var sy=window.pageYOffset||document.documentElement.scrollTop||0;
  var tot=r.height-SH;
  return {sy:sy, top:r.top+sy, tot:tot>0?tot:1};
}
function anchorY(i,G){ return i<=0 ? 0 : G.top + SNAP[i]*G.tot; }
function docMax(){
  var d=document.documentElement, bd=document.body;
  return Math.max(0, Math.max(d.scrollHeight, bd?bd.scrollHeight:0) - (window.innerHeight||SH));
}
function nearestStage(G){
  var best=0, bd=Infinity;
  for(var i=0;i<SNAP.length;i++){
    var d=Math.abs(G.sy-anchorY(i,G));
    if(d<bd){ bd=d; best=i; }
  }
  return best;
}
function swipeMin(){ return Math.max(16, SH*0.022); }
/* The moment the page is past Scene 3's own rest position it belongs to
   the reader: the DOWNWARD handover is immediate, so nothing can ever
   spring the page back, eat a swipe or ask for a second one.           */
var HANDOFF=1;
/* ---- Scene 3, the directional stop --------------------------------------
   Downward, Scene 3 is not a stage boundary at all: from its rest position
   to the footer nothing here intercepts, pins, snaps or animates the page,
   in any gesture, at any speed.
   Upward it is a hard stop. armUp is raised the moment the reader has
   genuinely travelled below Scene 3 (or any footer is on screen), and the
   FIRST frame in which the page is both moving upward and back at Scene 3's
   anchor, the page is caught there and held until whatever momentum is
   behind it has died against the stop - so one fast upward fling out of the
   footer can never carry through Scene 3 into Scene 2. The gesture that did
   the flinging is spent by the catch (swallow), so it cannot also count as
   a stage step. From then on Scene 3 is the settled stage again, and only a
   further, deliberate upward swipe carries on into the Stage 2 -> Stage 3
   transition.
   upCatch additionally pins the render clock to Scene 3's value for the
   duration of the catch, so a fling that overshoots by a few hundred pixels
   between two frames cannot show the COA running backwards before the stop
   takes hold. The prisms' own idle rotation and float are driven by the
   render clock, not by scroll, and continue right through all of it.    */
var fPrevSY=-1, swallow=0, armUp=0, upCatch=0;
function footerWatch(){
  var pv=fPrevSY; fPrevSY=SY0;
  if(!MB || RM) return;
  var up = (pv>=0) && (SY0 < pv-0.5);      /* the page is genuinely rising */
  if(FOOTV){
    /* Footer in view: hand the page over completely, and cancel anything
       already queued. Without this, a target committed a moment earlier
       could still pull the page up to Scene 2 from a mixed view.      */
    if(!freed || scrollBusy || target>=0 || snapRAF || snapT || mvOn){
      stopSnap();
      if(snapT){ clearTimeout(snapT); snapT=null; }
      scrollBusy=0; morphBusy=0; target=-1; mvOn=0; swallow=0; upCatch=0;
      setFreed(1);
    }
    armUp=1;                       /* the return upward will be caught */
    return;
  }
  if(!freed || scrollBusy) return;
  var tot = WTOT>0?WTOT:1, a3 = S1TOP + SNAP[LAST]*tot;
  /* Genuinely below Scene 3: the reader's territory, and the upward stop
     arms itself here. Nothing may touch the page in this zone.        */
  if(SY0 > a3 + Math.max(40, SH*0.08)){ armUp=1; return; }
  if(SY0 > a3 + 1) return;         /* just leaving Scene 3: hands off    */
  if(armUp){
    if(!up) return;                /* only ever caught on the way UP     */
    /* Catch the return AT Scene 3's anchor, in this very frame, and hold
       it there until the momentum behind it is spent.                  */
    armUp=0; upCatch=1;
    swallow = drag ? 1 : 0;        /* a gesture still running is spent   */
    mvOn=0; morphBusy=0; curStage=LAST; target=LAST; scrollBusy=1;
    setFreed(0);
    holdAt(a3, 300, function(){
      target=-1; scrollBusy=0; upCatch=0; curStage=LAST; applyTouchAction();
    });
    return;
  }
  /* Never went below Scene 3 and yet the page is above the transition -
     a jumped scroll, a restored position. Take the controller back from
     wherever the page actually is, without moving it.                  */
  if(prog >= E2B) return;
  curStage = nearestStage(geom());
  target=-1; morphBusy=0; mvOn=0; swallow=0;
  setFreed(0);
}
/* Pin the page at y until the momentum behind it is genuinely spent.
   The hold is adaptive rather than a fixed length: every frame the
   browser still tries to move the page away from y, the clock restarts.
   A fixed hold could expire while a hard fling was still running, and
   the moment the pin let go the page carried on - which is how leftover
   momentum used to turn into an unwanted extra stage step.            */
function holdAt(y,quiet,done){
  var calm=null, hardStop=null;
  stopSnap();
  window.scrollTo(0,y);
  snapRAF=requestAnimationFrame(function step(ts){
    if(hardStop===null) hardStop=ts+2200;      /* absolute safety limit */
    var drifted = Math.abs((window.pageYOffset||0) - y) > 2;
    window.scrollTo(0,y);
    if(drifted) calm=null;                      /* still fighting: reset */
    else if(calm===null) calm=ts;
    if((calm===null || ts-calm<quiet) && ts<hardStop){
      snapRAF=requestAnimationFrame(step); return;
    }
    snapRAF=null; tAccum=0; burst=0;
    if(done) done();
  });
}
function stopSnap(){ if(snapRAF){cancelAnimationFrame(snapRAF); snapRAF=null;} }
function resetSnap(){
  stopSnap();
  if(snapT){ clearTimeout(snapT); snapT=null; }
  tAccum=0; burst=0;
}
/* Eases the page to ty and calls done() once it is exactly there. */
function easeTo(ty,done,dur){
  var sy=(window.pageYOffset||0), d=ty-sy, s0=null, D=dur||460;
  stopSnap();
  if(Math.abs(d)<1){ snapRAF=null; if(done) done(); return; }
  snapRAF=requestAnimationFrame(function step(ts){
    if(s0===null) s0=ts;
    var u=Math.min(1,(ts-s0)/D);
    var e=u<0.5 ? 4*u*u*u : 1-Math.pow(-2*u+2,3)/2;   /* gentle in and out */
    window.scrollTo(0, sy+d*e);
    if(u<1){ snapRAF=requestAnimationFrame(step); return; }
    window.scrollTo(0,ty);              /* land exactly on the anchor */
    snapRAF=null; tAccum=0; burst=0;
    if(done) done();
  });
}
/* Commit to one destination and lock everything else out until it lands. */
function commitTo(i){
  i=Math.max(0,Math.min(LAST,i));
  /* Entering a scene: drop any transition, frame callback or pending
     settle still in flight, then re-read the canonical baseline so the
     scene starts from its original framing and never from a state another
     scene left behind.                                                  */
  stopSnap();
  if(snapT){ clearTimeout(snapT); snapT=null; }
  applyBaseline();
  var G=geom();
  target=i; scrollBusy=1; morphBusy=1;
  startMorph(SNAP[i]);                  /* pyramids begin their journey   */
  easeTo(anchorY(i,G), function(){
    curStage=i; target=-1; scrollBusy=0; /* the page has arrived: this is
                                            now the settled stage, so the
                                            next swipe steps from here    */
    if(i<LAST) armUp=0;                  /* left Scene 3 upward: disarm   */
    applyTouchAction();                  /* last stage: hand panning over */
  });
}
function startMorph(to){
  if(!MB || RM){ morphBusy=0; return; }
  mvFrom=pView; mvTo=to; mvT=0; mvOn=1; morphBusy=1;
}
function settleNearest(){
  if(!MB || RM || drag || scrollBusy || morphBusy || snapRAF || freed) return;
  if(FOOTV || footerShown()) return;          /* footer on screen: hands off */
  var G=geom(), n=nearestStage(G);
  /* Past Scene 3's rest position: that is the run to the footer. Hand the
     page over at once - never pull it back, never ask for another swipe. */
  if(curStage>=LAST && G.sy>anchorY(LAST,G)+HANDOFF){ setFreed(1); return; }
  if(Math.abs(G.sy-anchorY(n,G))<4){ curStage=n; return; }   /* already there */
  commitTo(Math.max(curStage-1, Math.min(curStage+1, n)));   /* never skip */
}
/* The controller drives the page only while there is still a stage ahead
   of the reader. Once Scene 3 is settled it hands vertical panning back to
   the browser, so a downward swipe there is an ordinary native scroll with
   its own momentum - no second animation, no jump to the end of the
   document, nothing competing with the finger.                          */
/* The single authority for whether the stage controller may touch the
   page. Any sliver of footer on screen - including a mixed view with part
   of the COA still showing - is ordinary page territory and the
   controller keeps its hands off entirely.                            */
function locked(){ return MB && !RM && !freed && !FOOTV && curStage<LAST; }
function applyTouchAction(){
  if(W && W.style) W.style.touchAction = locked() ? '' : 'auto';
}
function setFreed(v){ freed = v?1:0; applyTouchAction(); }
addEventListener('touchstart',function(e){
  drag=1; swallow=0;             /* never let a latch survive a gesture */
  if(snapT){ clearTimeout(snapT); snapT=null; }
  tPrevY = e.touches&&e.touches[0] ? e.touches[0].clientY : 0;
  tAccum=0; dragWant=0;
  dragG = geom();                       /* one read for the whole gesture */
  if(scrollBusy) return;                /* a committed move owns the page */
  stopSnap();
  /* Resync the settled stage ONLY when the page is genuinely resting on
     one. Reading it mid-flight is what produced the snap-back.        */
  if(MB && !RM && !morphBusy){
    var n=nearestStage(dragG);
    if(Math.abs(dragG.sy-anchorY(n,dragG))<6) curStage=n;
  }
},{passive:true});
addEventListener('touchmove',function(e){
  if(!MB || RM || !e.touches || !e.touches[0]) return;
  var y=e.touches[0].clientY;
  tAccum += (tPrevY-y); tPrevY=y;       /* always, so direction is known */
  if(!locked()) return;
  e.preventDefault();                   /* no native scroll, no fling     */
  if(scrollBusy) return;                /* never fight a committed move   */
  dragWant = 1;                         /* one scroll write per frame     */
},{passive:false});
var dragWant=0, dragG=null;
function dragApply(){
  if(!dragWant || !drag || !locked() || scrollBusy) return;
  dragWant=0;
  var G=dragG||geom();
  var span = G.tot*0.5*(SNAP[1]-SNAP[0]);
  var off  = Math.max(-span, Math.min(span, tAccum*0.34));
  window.scrollTo(0, anchorY(curStage,G)+off);
}
function endSwipe(){
  drag=0;
  if(!MB || RM){ tAccum=0; return; }
  var moved=tAccum; tAccum=0;
  /* any footer on screen - even alongside part of Scene 3 - means this
     gesture is ordinary scrolling and must produce no stage move at all */
  if(footerShown()){ swallow=0; return; }
  if(scrollBusy) return;                /* destination already committed  */
  var TH=swipeMin(), G=geom();
  if(swallow){ swallow=0; return; }   /* this gesture was spent catching
                                         the return to Scene 3 - it must
                                         not also step to Scene 2      */
  if(freed){
    /* Below Scene 3 the page belongs entirely to the reader: free native
       scrolling with its own momentum, and nothing here moves it. The
       upward return is caught by footerWatch(), at Scene 3's anchor and
       nowhere else.                                                    */
    return;
  }
  if(curStage>=LAST){
    /* Scene 3, settled. Downward is the ordinary run to the footer: ANY
       downward gesture, however small, hands the page over for good - no
       ease, no target, no morph clock, nothing that could pull it back,
       block it or ask for a second swipe. Upward is the deliberate
       continue into the Stage 2 -> Stage 3 transition.                */
    if(moved>0){
      setFreed(1); resetSnap();
      mvOn=0; morphBusy=0; scrollBusy=0; target=-1; swallow=0; upCatch=0;
      return;
    }
    if(-moved<TH) return;               /* an upward nudge: leave it be  */
    armUp=0;                            /* a deliberate continue upward  */
    commitTo(LAST-1);                   /* back toward Scene 2           */
    return;
  }
  if(Math.abs(moved)<TH){ settleNearest(); return; }        /* just a nudge */
  var dn = moved>0;
  if(!dn && curStage<=0){ commitTo(0); return; }
  commitTo(curStage + (dn?1:-1));       /* exactly one adjacent stage      */
}
addEventListener('touchend',function(){ endSwipe(); },{passive:true});
addEventListener('touchcancel',function(){
  drag=0; tAccum=0; dragWant=0; swallow=0;
  if(!scrollBusy){ resetSnap(); settleNearest(); }   /* clear locks safely */
},{passive:true});
/* Same rules for narrow-viewport scrolling that is not touch driven. */
function armSettle(){
  if(!MB || RM || drag || scrollBusy || morphBusy || snapRAF) return;
  if(FOOTV) return;                            /* footer on screen: hands off */
  if(snapT) clearTimeout(snapT);
  snapT=setTimeout(function(){
    snapT=null; burst=0;
    if(drag||scrollBusy||morphBusy||snapRAF) return;
    var G=geom(), n=nearestStage(G);
    /* below Scene 3 nothing settles: footerWatch() owns the way back */
    if(freed) return;
    if(dirDown && curStage>=LAST && G.sy>=anchorY(LAST,G)+HANDOFF){ setFreed(1); return; }
    settleNearest();
  },150);
}
layout(); measure(); pView=prog; applyTouchAction();
addEventListener('resize',function(){
  layout(); measure();
  /* geometry moved: drop every temporary lock and start clean */
  resetSnap(); setFreed(0); scrollBusy=0; morphBusy=0; target=-1; mvOn=0;
  swallow=0; armUp=0; upCatch=0; fPrevSY=-1;
  if(MB && !RM){
    curStage=nearestStage(geom());
    snapT=setTimeout(function(){ snapT=null; settleNearest(); },220);
  }
},{passive:true});
addEventListener('scroll',function(){
  onScroll();
  var sy=window.pageYOffset||0;
  if(sy!==lastSY){
    /* Scroll we caused ourselves - the committed move or the damped drag -
       is not user input and must never steer direction, the settled stage
       or the release flag.                                             */
    if(drag || snapRAF || scrollBusy){ lastSY=sy; return; }
    var down = sy>lastSY;
    /* a new burst, or a change of direction inside one, resyncs the stage
       to wherever the page actually is before the next decision.        */
    if(!burst || down!==dirDown){
      if(MB && !RM) stage=nearestStage(geom());
      burst=1;
    }
    dirDown=down; lastSY=sy;
  }
  armSettle();
},{passive:true});
window.VPH={pv:function(){return pView;},mv:function(){return mvOn;},N:N,P:P,SX:SX,SY:SY,SA:SA,SK:SK,SZW:SZW,SPZ:SPZ,SV:SV,SZ:SZ,RM:RM,MB:MB,
  compute:computeFrame, vw:function(){return vw;}, vh:function(){return vh;}};
function start2D(){ g=cv.getContext('2d',{alpha:true}); requestAnimationFrame(frame2D); }
if(typeof VPH_BOOT==='function') VPH_BOOT(start2D); else start2D();
})();